<template>
<div>
    <div>
        <div class="float-left">
            <h5 class="mb-0 text-primary">Meal {{ index+1 }}</h5>
        </div>
        <div class="float-right">
            <a href="#" @click.prevent="regenerate(meal)" title="Auto-pick this meal"><i class="mdi mdi-24px mdi-reload" style="line-height:24px;"></i></a>
            <a href="#" @click.prevent="startChooseAlternative" title="Choose alternative meal from list"><i class="mdi mdi-24px mdi-food" style="line-height:24px;"></i></a>
            <a href="#" @click.prevent="startUpdateMacros" title="Update target macros"><i class="mdi mdi-24px mdi-scale-balance" style="line-height:24px;"></i></a>
        </div>
    </div>
    <table class="table table-xs table-hover" :class="{ loading: meal.isLoading }">
        <thead class="thead-light">
            <tr>
                <th scope="col"></th>
                <th scope="col">Food</th>
                <th scope="col" class="text-right">Amount</th>
                <th scope="col" class="text-right">Cals</th>
                <th scope="col" class="text-right">P (g)</th>
                <th scope="col" class="text-right">C (g)</th>
                <th scope="col" class="text-right">F (g)</th>
            </tr>
        </thead>
        <tbody is="meal-foods" :foods="meal.foods" :meal="meal" @food-updated="foodUpdated"></tbody>

        <tfoot>
            <tr>
                <td></td>
                <td><a href="#" @click.prevent="openAddFoodModal()"><i class="mdi mdi-plus"></i>Add Food</a></td>
                <td class="text-right text-muted">Target:</td>
                <td class="text-right text-muted">{{ meal.target_calories | toFixed(0) }}</td>
                <td class="text-right text-muted">{{ meal.target_protein_g | toFixed(0) }}</td>
                <td class="text-right text-muted">{{ meal.target_carbohydrate_g | toFixed(0) }}</td>
                <td class="text-right text-muted">{{ meal.target_fat_g | toFixed(0) }}</td>
            </tr>
            <tr v-if="meal.calories">
                <td colspan="2" align="right" class="text-muted">
                  <a class="small text-muted" target="_blank" :href="editMealSettingLink"  v-if="hasFoods && mealSettingExists">Edit Meal Setting <i class="mdi mdi-open-in-new"></i></a>
                </td>
                <td align="right" class="text-muted">Actual:</td>
                <td class="text-right" v-bind:class="within5pctClass(meal.calories,meal.target_calories)">{{ meal.calories | toFixed(0) }}</td>
                <td class="text-right" v-bind:class="within5pctClass(meal.protein_g,meal.target_protein_g)">{{ meal.protein_g | toFixed(0) }}</td>
                <td class="text-right" v-bind:class="within5pctClass(meal.carbohydrate_g,meal.target_carbohydrate_g)">{{ meal.carbohydrate_g | toFixed(0) }}</td>
                <td class="text-right" v-bind:class="within5pctClass(meal.fat_g,meal.target_fat_g)">{{ meal.fat_g | toFixed(0) }}</td>
            </tr>
        </tfoot>
    </table>

    <div class="alert border-info alert-info w-100" v-if="hasFoods && !mealSettingExists">
        This Meal Setting does not exist! Create it?<br>
        <a class="btn btn-sm btn-secondary" target="_blank" :href="createMealSettingLink">Create Meal Setting <i class="mdi mdi-open-in-new"></i></a>
    </div>

    <modal v-if="showUpdateMacrosModal" @close="showUpdateMacrosModal=false">
        <h3 slot="header">Update macro targets for Meal {{ index+1 }}</h3>
        <div slot="body">
            <table class="table table-sm table-hover">
                <thead class="thead-light">
                    <tr>
                        <th></th>
                        <th>Original</th>
                        <th>New</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Calories</td>
                        <td>{{ meal.target_calories | toFixed(2)}}</td>
                        <td><input type="number" style="width:120px;" step="1" class="form-control" placeholder="Total Calories" required v-model="updatedMacros.calories" @keyup="updateTargetCalories"></td>
                    </tr>
                    <tr>
                        <td>Protein (g)</td>
                        <td>{{ meal.target_protein_g | toFixed(2)}}</td>
                        <td><input type="number" style="width:120px;" step="1" class="form-control" placeholder="Protein in grams" required v-model="updatedMacros.protein" @keyup="updateTargetProtein"></td>
                    </tr>
                    <tr>
                        <td>Carbohydrate (g)</td>
                        <td>{{ meal.target_carbohydrate_g | toFixed(2)}}</td>
                        <td><input type="number" style="width:120px;" step="1" class="form-control" placeholder="Carbs in grams" required v-model="updatedMacros.carbohydrate" @keyup="updateTargetCarbohydrate"></td>
                    </tr>
                    <tr>
                        <td>Fat (g)</td>
                        <td>{{ meal.target_fat_g | toFixed(2)}}</td>
                        <td><input type="number" style="width:120px;" step="1" class="form-control" placeholder="Fat in grams" required v-model="updatedMacros.fat" @keyup="updateTargetFat"></td>
                    </tr>
                </tbody>
            </table>
            <div class="">
                  <div class="form-group">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="regenrate-meal-toggle" v-model="updatedMacros.regenerateMeal">
                      <label class="form-check-label" for="regenrate-meal-toggle">
                        Regenerate meal
                      </label>
                    </div>
                  </div>
                <button @click="updateMacros()" class="btn btn-primary">Update</button>
                <button @click="resetUpdatedMacros()" class="btn btn-secondary">Reset</button>
            </div>
        </div>
        <div slot="footer">
          <button class="btn btn-default" @click="showUpdateMacrosModal = false">
            Cancel
          </button>
        </div>
    </modal>

    <modal v-if="showAddFoodModal" @close="closeAddFoodModal()">
        <h3 slot="header">Add {{ FoodToAdd ? FoodToAdd.name : 'Food' }}</h3>
        <div slot="body">
            <div v-show="!FoodToAdd">
                <input type="text" class="form-control mb-2" id="food_list_filter" required v-model="food_list_filter" ref="food_filter_input" placeholder="Filter">
                <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" id="show_only_chosen_foods" v-model="show_only_chosen_foods">
                    <label class="form-check-label" for="show_only_chosen_foods">Show only chosen foods</label>
                </div>
            </div>

            <dl v-show="!FoodToAdd">
                <template v-for="(food, index) in filteredFoodsSorted" v-bind="index">
                    <dt v-bind:key="(index+'dt')" :class="{'text-muted': mealHasFoodId(food.id)}">
                        <a v-if="!mealHasFoodId(food.id)" href="#" @click.prevent="chooseFoodToAdd(food)">{{ food.name }}</a>
                        <span v-if="mealHasFoodId(food.id)"> {{ food.name }} (Already in meal )</span>
                    </dt>
                    <dd style="margin-left:1rem;" v-bind:key="(index+'dd')">
                        {{ food.description }}
                    </dd>
                </template>
            </dl>
            <div v-if="FoodToAdd">
                <!-- <h2>{{ FoodToAdd.name }}</h2> -->
                <!-- <h2>{{ FoodToAdd }}</h2> -->
                <div class="form-row align-items-center mb-2">

                    <div class="col-auto">
                      <label for="food_to_add_weight_select">Unit</label>
                      <!-- <div class="form-group"> -->
                        <select id="food_to_add_weight_select" class="form-control" v-model="FoodToAddFoodWeight">
                          <option disabled value="">Please select one</option>
                          <option
                            v-for="foodWeight in FoodToAdd.food_weights"
                            v-bind:key="foodWeight.id"
                            :value="foodWeight"
                            >{{foodWeight.name }} <template v-if="foodWeight.name!='grams'">({{ foodWeight.grams | trimDecimal }}g)</template>
                            <!-- <span>({{ foodWeight.type }})</span> -->
                            <!-- <span v-if="workoutPlan.workout_program_id == foodWeight.id">(current)</span> -->
                          </option>
                        </select>
                      <!-- </div> -->
                    </div>

                    <div class="col-auto">
                        <label for="food-to-add-amount">Amount</label>
                        <input type="number" id="food-to-add-amount" :step="foodToAddAmountStep" min="0" class="form-control" :placeholder="foodToAddAmountPlaceholder" required v-model="FoodToAddAmount" :disabled="!FoodToAddFoodWeight">
                    </div>

                    <!-- <div class="col-auto">
                        <button @click="setFoodToAddMax()" class="btn btn-secondary"><i class="mdi mdi-gas-station"></i> Fill 'er up!</button>
                    </div> -->
                </div>
                <div class="my-2">
                    <table class="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th class="text-right" scope="col"></th>
                                <th class="text-right" scope="col">Cals</th>
                                <th class="text-right" scope="col">Prot (g)</th>
                                <th class="text-right" scope="col">Carbs (g)</th>
                                <th class="text-right" scope="col">Fat (g)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>This: </td>
                                <td class="text-right">{{ food_calories_for_amount(FoodToAdd, FoodToAddAmount) | toFixed(0) }}</td>
                                <td class="text-right">{{ food_protein_for_amount(FoodToAdd, FoodToAddAmount) | toFixed(0) }}</td>
                                <td class="text-right">{{ food_carbohydrate_for_amount(FoodToAdd, FoodToAddAmount) | toFixed(0) }}</td>
                                <td class="text-right">{{ food_fat_for_amount(FoodToAdd, FoodToAddAmount) | toFixed(0) }}</td>
                            </tr>
                            <tr>
                                <td align="text-right" class="text-muted">Target:</td>
                                <td class="text-right">{{ meal.target_calories-meal.calories | toFixed(0) }}</td>
                                <td class="text-right">{{ meal.target_protein_g-meal.protein_g | toFixed(0) }}</td>
                                <td class="text-right">{{ meal.target_carbohydrate_g-meal.carbohydrate_g | toFixed(0) }}</td>
                                <td class="text-right">{{ meal.target_fat_g-meal.fat_g | toFixed(0) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="">
                    <button @click="addFood()" class="btn btn-primary" :disabled="FoodToAddAmount > 0 && FoodToAddAmount <= 9999 ? false : true">Add Food</button>
                    <button @click="FoodToAdd=null;FoodToAddAmount=null;" class="btn btn-default">Change Food</button>
                </div>
            </div>
        </div>
        <div slot="footer">
          <button class="btn btn-default" @click="closeAddFoodModal()">
            Cancel
          </button>
        </div>
    </modal>

    <modal v-if="showChooseAlternativeMealModal" @close="showChooseAlternativeMealModal=false">
        <template slot="header">
          <h3>Choose Alternative Meal</h3>
        </template>
        <div slot="body">
          <div v-if="!chosenAlternativeMealSetting">
            <table class="table table-sm table-hover table-striped">
              <thead>
                <tr>
                  <th scope="col">Foods</th>
                  <th scope="col">Cals</th>
                  <th scope="col">Macros</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(mealOption, index) in availableMealOptions" v-bind:key="index">
                  <td>
                    <ul v-if="mealOption.foods" style="padding-left: 0; list-style-type: none;">
                      <li v-for="(food, index) in mealOption.foods" v-bind:key="index">
                        {{ food.name }} - {{ food.amount }} ({{ getFoodWeightNameFromId(food.food_weight_id) }} )g
                      </li>
                    </ul>
                    <small>Total options found: {{ mealOption.found_options }}</small>
                  </td>
                  <td>
                    {{ mealOption.calories }}<br>
                    <span class="text-muted">(Δ{{ mealOption.calorie_delta }})</span>
                  </td>
                  <td>
                    {{ mealOption.protein_g }} p <br>
                    {{ mealOption.carbohydrate_g }} c <br>
                    {{ mealOption.fat_g }} f
                  </td>
                  <td>
                    <button @click="chooseAlternativeMealOption(mealOption)" class="btn btn-sm btn-primary"><i class="mdi mdi-check"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="chosenAlternativeMealSetting">
            <div class="text-center mt-5" v-if="availableMealSettingOptionsCount == null">
              <div class="spinner-border" style="width: 5rem; height: 5rem;" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div>
              <div class="alert alert-danger" v-if="availableMealSettingOptionsCount==0">No options available within {{ lastMealSettingOptionThresholdPct }}%</div>
              <div class="alert alert-info" v-if="availableMealSettingOptionsCount">{{ availableMealSettingOptions.length }} options available within {{ lastMealSettingOptionThresholdPct }}%</div>
            </div>
            <div v-if="availableMealSettingOptionsCount!=null">
              <form @submit.prevent="onSubmit">
                <div class="input-group mb-3">
                <input type="number" step="1" class="form-control" placeholder="Threshold Percent" required v-model="mealSettingOptionThresholdPct">
                  <div class="input-group-append">
                    <input type="submit" value="Try again" class="btn btn-outline-secondary" @click="fetchOptionsForMealSetting(chosenAlternativeMealSetting)">
                  </div>
                </div>
              </form>
            </div>

            <div v-if="availableMealSettingOptionsCount">
              <table class="table table-sm table-hover">
                <thead>
                  <tr>
                    <th scope="col">Foods</th>
                    <th scope="col">Cals</th>
                    <th scope="col">Macros</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(option, index) in availableMealSettingOptions" v-bind:key="index">
                    <td>
                      <ul v-if="option.foods" style="padding-left: 0; list-style-type: none;">
                        <li v-for="(food, index) in option.foods" v-bind:key="index">
                          {{ food.amount }}g - {{ food.name }}
                        </li>
                      </ul>
                    </td>
                    <td>
                      {{ option.calories }}<br>
                      <span class="text-muted">(Δ{{ option.calorie_delta }})</span>
                    </td>
                    <td>
                      {{ option.protein_g }} p <br>
                      {{ option.carbohydrate_g }} c <br>
                      {{ option.fat_g }} f
                    </td>
                    <td>
                      <button @click="chooseAlternativeMealOption(option)" class="btn btn-sm btn-primary"><i class="mdi mdi-check"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div slot="footer">
          <button v-if="chosenAlternativeMealSetting" @click="chosenAlternativeMealSetting=null;availableMealSettingOptionsCount=null;" class="btn btn-secondary">&lt; Change Meal</button>
          <button class="btn btn-default" @click="showChooseAlternativeMealModal = false">
            Cancel
          </button>
        </div>
    </modal>
</div>

</template>
<script>
  export default {
    props: [
      'initialMeal',
      'index'
    ],
    data() {
      return {
        meal: this.initialMeal,
        showAddFoodModal: false,
        FoodToAdd: null,
        FoodToAddAmount: null,
        FoodToAddFoodWeight: null,
        showChooseAlternativeMealModal: false,
        availableMealSettings: [],
        availableMealSettingOptions: [],
        mealSettingOptionThresholdPct: 5,
        lastMealSettingOptionThresholdPct: 5,
        chosenAlternativeMealSetting: null,
        availableMealSettingOptionsCount: null,
        showUpdateMacrosModal: false,
        mealSettingExists: true,
        mealSettingId: null,
        updatedMacros: {
          'calories': this.initialMeal.target_calories,
          'protein': this.initialMeal.target_protein_g,
          'carbohydrate': this.initialMeal.target_carbohydrate_g,
          'fat': this.initialMeal.target_fat_g,
          'regenerateMeal': false,
        },
        food_list_filter: null,
        show_only_chosen_foods: true
      }
    },
    mounted() {
      // this.getAllFoods();
      // This does way too many calls on load. Let's do it smarter..
      this.doesMealSettingExist();
    },
    computed: {
      allFoodsSorted: function() {
        return this.$root.allFoodsSorted;
      },
      filteredFoodsSorted: function() {
        var _this = this;
        if (this.show_only_chosen_foods == true) {
          var foods = this.$root.selectedFoodsSorted;
        } else {
          var foods = this.$root.allFoodsSorted;
        }

        if (_this.food_list_filter !== null) {
          foods = foods.filter(function (food) {
            return food.name.search(new RegExp(_this.food_list_filter, "i")) !== -1;
          });
        }

        return foods;
      },
      hasFoods: function() {
        return this.meal.foods.length >= 1;
      },
      createMealSettingLink: function() {
        return '/coach/meal_settings/create?food_ids=' + _.map(this.meal.foods, 'id').join(',');
      },
      editMealSettingLink: function() {
        return '/coach/meal_settings/' + this.mealSettingId + '/edit';
      },
      foodToAddAmountPlaceholder: function(){
        var unit = "unit";
        if (this.FoodToAddFoodWeight) {
          unit = this.FoodToAddFoodWeight.name
        }
        return "Amount of " + unit;
      },
      foodToAddAmountStep: function(){
        var step = 1;
        if (this.FoodToAddFoodWeight && this.FoodToAddFoodWeight.default_increment_amount) {
          step = this.FoodToAddFoodWeight.default_increment_amount;
        }
        return step;
      },
    },
    methods: {
      getFoodWeightNameFromId: function(food_weight_id) {
        var result = _.find(this.$root.allFoodWeights, function(food_weight) {
            return food_weight.id == food_weight_id;
        })
        // console.log("Looking for Food Weight ID: " + food_weight_id);
        // console.log(result);
        return result.name;
      },
      mealHasFoodId: function(food_id) {
        return this.meal.foods.filter(function(food) { return food.id == food_id}).length > 0;
      },
      getMeal: function getMeal(id) {
        return axios.get('/api/meal_plan_day_meals/' + id)
          .then((response) => {
            return response.data.data;
          });
      },
      doesMealSettingExist: function () {
        var _this = this;
        if (this.meal.foods.length == 0) {
          return;
        }
        var food_ids = _.map(this.meal.foods, 'id').join(',');
        axios.get('/api/meal_settings?food_ids=' + food_ids)
          .then((response) => {
            console.log("items:", response.data.data);
            _this.mealSettingExists = (response.data.data.length >= 1) ? true : false;
            _this.mealSettingId = response.data.data[0].id;
          }).catch(e => {
            _this.mealSettingExists = false;
          });
      },
      startUpdateMacros: function () {
        var _this = this;
        _this.showUpdateMacrosModal = true;
      },
      updateMacros: function () {
        var _this = this;
        Vue.set(_this.meal, 'isLoading', true);
        axios.put('/api/meal_plan_day_meals/' + this.meal.id, {
          'target_calories': this.updatedMacros.calories,
          'target_protein_g': this.updatedMacros.protein,
          'target_carbohydrate_g': this.updatedMacros.carbohydrate,
          'target_fat_g': this.updatedMacros.fat,
          'regenerate_meal': this.updatedMacros.regenerateMeal,
        }).then((response) => {
          // var data = response.data.data;
          _this.$emit('meal-updated');
          Object.assign(_this.meal, response.data.data);
          _this.showUpdateMacrosModal = false;
          Vue.set(_this.meal, 'isLoading', false);
        });
      },
      resetUpdatedMacros: function () {
        this.updatedMacros = {
          'calories': this.initialMeal.target_calories,
          'protein': this.initialMeal.target_protein_g,
          'carbohydrate': this.initialMeal.target_carbohydrate_g,
          'fat': this.initialMeal.target_fat_g
        };
      },
      updateTargetCalories: function () {
        // if calories changes, alter carbs.
        var protein_calories = parseFloat(this.updatedMacros.protein)*4;
        var fat_calories = parseFloat(this.updatedMacros.fat)*9;
        var calories = parseFloat(this.updatedMacros.calories);

        this.updatedMacros.carbohydrate = ((calories - protein_calories - fat_calories)/4).toFixed(2);
      },
      updateTargetProtein: function () {
        // if protein changes, alter carbs.
        this.updateTargetCalories();
      },
      updateTargetFat: function () {
        // if fat changes, alter carbs.
        this.updateTargetCalories();
      },
      updateTargetCarbohydrate: function () {
        // if carbohydrate changes, alter fat.
        var protein_calories = parseFloat(this.updatedMacros.protein)*4;
        // var fat_calories = parseFloat(this.updatedMacros.fat)*9;
        var carbohydrate_calories = parseFloat(this.updatedMacros.carbohydrate)*4;
        var calories = parseFloat(this.updatedMacros.calories);

        this.updatedMacros.fat = ((calories - protein_calories - carbohydrate_calories)/9).toFixed(2);
        // this.updateTargetCalories();
      },
      regenerate: function (meal) {
        var _this = this;
        Vue.set(meal, 'isLoading', true);
        axios.post('/api/meal_plan_day_meals/' + meal.id + '/regenerate', {}).then(function (response) {
          _this.$emit('meal-updated');
          Object.assign(meal, response.data.data);
          Vue.set(meal, 'isLoading', false);
        })
        .catch(e => {
          // this.errors.push(e)
          // console.log(e.response.data.message);
          _this.$emit('meal-updated');
          _this.$toasted.error(e.response.data.message);
          Vue.set(meal, 'isLoading', false);
        })
      },
      startChooseAlternative: function () {
        var _this = this;
        axios.get('/api/meal_plan_day_meals/' + this.meal.id + '/find_meal_options')
          .then((response) => {
            _this.showChooseAlternativeMealModal = true;
            _this.availableMealOptions = response.data.data;
          });
      },
      fetchOptionsForMealSetting: function (mealSetting) {
        var _this = this;
        _this.chosenAlternativeMealSetting = mealSetting;
        _this.availableMealSettingOptionsCount=null;
        _this.lastMealSettingOptionThresholdPct=_this.mealSettingOptionThresholdPct;
        axios.get('/api/meal_options', {
          params: {
            'meal_setting_id': mealSetting.id,
            'protein_g': _this.meal.target_protein_g,
            'carbohydrate_g': _this.meal.target_carbohydrate_g,
            'fat_g': _this.meal.target_fat_g,
            'threshold_pct': (_this.mealSettingOptionThresholdPct*.01)
          }})
          .then((response) => {
            _this.availableMealSettingOptions = response.data.data;
            _this.availableMealSettingOptionsCount = response.data.data.length;
          });
      },
      chooseAlternativeMealOption: function(option) {
        var _this = this;
        Vue.set(_this.meal, 'isLoading', true);
        let foods = option.foods.map(function(f) {
          return {'id': f.id, 'amount': f.amount, 'food_weight_id': f.food_weight_id}
        });
        axios.post('/api/meal_plan_day_meals/' + _this.meal.id + '/replace', {
          'foods': foods
          // 'meal_option_id': option.id
        }).then(function (response) {
          _this.$emit('meal-updated');
          Object.assign(_this.meal, response.data.data);
          _this.showChooseAlternativeMealModal = false;
          _this.availableMealSettingOptions = [];
          _this.availableMealSettingOptionsCount = null;
          _this.chosenAlternativeMealSetting = null;
          Vue.set(_this.meal, 'isLoading', false);
        });
      },
      foodUpdated: function (pivotId) {
        var _this = this;
        Vue.set(_this.meal, 'isLoading', true);
        this.getMeal(this.meal.id)
          .then(function (freshMeal) {
              Object.assign(_this.meal, freshMeal);
              Vue.set(_this.meal, 'isLoading', false);
              _this.doesMealSettingExist();
              _this.$emit('meal-updated');
          });
      },
      chooseFoodToAdd: function(food) {
        this.FoodToAdd = food;
        this.$nextTick(function(){
            document.getElementById('food_to_add_weight_select').focus();
            // document.getElementById('food-to-add-amount').focus();
        }.bind(this));
      },
      setFoodToAddMax: function () {
        var food_amount_for_target_calories = this.food_amount_for_target_calories(this.FoodToAdd, this.meal.target_calories-this.meal.calories)
        var food_amount_for_target_protein = this.food_amount_for_target_protein(this.FoodToAdd, this.meal.target_protein_g-this.meal.protein_g)
        var food_amount_for_target_carbohydrate = this.food_amount_for_target_carbohydrate(this.FoodToAdd, this.meal.target_carbohydrate_g-this.meal.carbohydrate_g)
        var food_amount_for_target_fat = this.food_amount_for_target_fat(this.FoodToAdd, this.meal.target_fat_g-this.meal.fat_g)

        var amounts = [
          food_amount_for_target_calories,
          food_amount_for_target_protein,
          food_amount_for_target_carbohydrate,
          food_amount_for_target_fat
        ];

        // Get the smallest value
        var max_amount = Math.min.apply(Math, amounts)

        // Set it!
        this.FoodToAddAmount = max_amount;
      },
      addFood: function () {
        var _this = this;
        Vue.set(_this.meal, 'isLoading', true);

        axios.post('/api/meal_plan_day_meal_foods/', {
          meal_plan_day_meal_id: _this.meal.id,
          food_id: _this.FoodToAdd.id,
          amount: _this.FoodToAddAmount,
          food_weight_id: _this.FoodToAddFoodWeight.id
        }).then(function (response) {
          // Object.assign(_this.meal, response.data.data);
          _this.foodUpdated();
          _this.closeAddFoodModal();
          _this.$emit('meal-updated');
          Vue.set(_this.meal, 'isLoading', false);
        })
        .catch(e => {
          _this.$toasted.error(e.response.data.message);
          _this.closeAddFoodModal();
          Vue.set(_this.meal, 'isLoading', false);
        });
      },
      openAddFoodModal: function () {
        this.showAddFoodModal = true;
        this.$nextTick(function(){
          this.$refs.food_filter_input.focus();
          // document.getElementById('food_filter_input').focus();
        }.bind(this));
      },
      closeAddFoodModal: function () {
        this.FoodToAdd = null;
        this.FoodToAddAmount = null;
        this.showAddFoodModal = false;
        this.food_list_filter = null;
      },
      within5pctClass: function within5pctClass(newVal, oldVal) {
        return this.$parent.within5pctClass(newVal, oldVal);
      },
      foodToAddFoodWeightGrams(){
        return (this.FoodToAddFoodWeight.grams / this.FoodToAddFoodWeight.amount) * this.FoodToAddAmount;
      },
      food_calories_for_amount(food, amount) {
        if (!this.FoodToAddFoodWeight) { return 0; }
        return (food.calories_per_100g/100)*this.foodToAddFoodWeightGrams();
      },
      food_protein_for_amount(food, amount) {
        if (!this.FoodToAddFoodWeight) { return 0; }
        return (food.protein_g/100)*this.foodToAddFoodWeightGrams();
        // return (food.protein_g/100)*amount;
      },
      food_carbohydrate_for_amount(food, amount) {
        if (!this.FoodToAddFoodWeight) { return 0; }
        return (food.carbohydrate_g/100)*this.foodToAddFoodWeightGrams();
        // return (food.carbohydrate_g/100)*amount;
      },
      food_fat_for_amount(food, amount) {
        if (!this.FoodToAddFoodWeight) { return 0; }
        return (food.fat_g/100)*this.foodToAddFoodWeightGrams();
        // return (food.fat_g/100)*amount;
      },
      food_amount_for_target_calories(food, target) {
        if (target <= 1) target = 1; // This prevents weird negative behavior
        return Math.floor(target/(food.calories_per_100g/100));
      },
      food_amount_for_target_protein(food, target) {
        if (target <= 1) target = 1; // This prevents weird negative behavior
        return Math.floor(target/(food.protein_g/100));
      },
      food_amount_for_target_carbohydrate(food, target) {
        if (target <= 1) target = 1; // This prevents weird negative behavior
        return Math.floor(target/(food.carbohydrate_g/100));
      },
      food_amount_for_target_fat(food, target) {
        if (target <= 1) target = 1; // This prevents weird negative behavior
        return Math.floor(target/(food.fat_g/100));
      }
    },
    watch: {
      initialMeal: function (newVal,oldVal) {
        Vue.set(this, 'meal', newVal);
      },
      // meal: function (newVal,oldVal) {
      //     // var old_food_ids = _.map(oldVal.foods, 'id').sort().join('-')
      //     // var new_food_ids = _.map(newVal.foods, 'id').sort().join('-')
      //     // console.log(old_food_ids);
      //     // console.log(new_food_ids);
      //     // // if (!_.isEqual(newVal.foods, oldVal.foods)){
      //     // if (old_food_ids != new_food_ids){
      //     //     // Vue.set(this, 'meal', newVal);
      //     //     this.doesMealSettingExist();
      //     // }
      // },
    }
}
</script>
